import React, { Component } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import style from "./CreateAccount.module.css";
import api from "../../utils/Api";
import { Link } from "react-router-dom";
import ttmLodader from "../../assets/images/ttm-loader.gif";
import { connect } from "react-redux";
import { verifyLicense } from '../../redux';

const alreadyInUseEmail = [];

export class CreateAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      model:{
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        confirmPassword: "",
        licenseKey: "",
        isLicenseVerified: false,
      },
      isLoading: false,
      isLicenseKeyLoading: false,
    };
  }

  validateLicenseKey = async() => {
   // if(this.state.model.licenseKey){
      this.setState({
        isLicenseKeyLoading: true,
      });
      await this.props.verifyLicense(this.state.model.licenseKey);
      if(!this.props.licenseStatusData.loading){
       // console.log("this.props.licenseStatusData",this.props.licenseStatusData)

        if(this.props.licenseStatusData.licenseStatus.status){
          this.setState({
            successMessage: this.props.licenseStatusData.successMessage,
            errorMessage: "",
            model:{
              ...this.state.model,
            firstName: this.props.licenseStatusData.licenseStatus.firstname,
            lastName: this.props.licenseStatusData.licenseStatus.lastname,
            email: this.props.licenseStatusData.licenseStatus.email,
            isLicenseVerified: true
            }
          })
          
          setTimeout(() => {
            this.setState({
              successMessage: "",
            });
          }, 2000);

        }else{
          this.setState({
            errorMessage: this.props.licenseStatusData.licenseStatus.message,
            successMessage: "",
          })

          setTimeout(() => {
            this.setState({
              errorMessage: "",
            });
          }, 2000);
        }

        this.setState({
          isLicenseKeyLoading: false,
        });
      }
   // }
  }

  handleInputChange = (event) => {
    let name = event.target.name;
    let val = event.target.value;
    this.setState({
      model:{
        ...this.state.model,
        [name]: val
      },
      errorMessage: ""
    })
  }

  render() {
    return (
      <React.Fragment>
        <div className={style.createAccMainWrapper}>
          <div className="container h-100">
            <div className={`row ${style.alignCenter}`}>
              <div className="col-md-12">
                <Formik
                  initialValues={this.state.model}
                  enableReinitialize={true}
                  validationSchema={Yup.object().shape({
                    firstName: Yup.string().trim().required("First Name is required!"),
                    lastName: Yup.string().trim().required("Last Name is required!"),
                    licenseKey: Yup.string().trim()
                    .when("isLicenseVerified", {
                      is: false,
                      then: Yup.string()
                        .required("Verified license is required!")
                      }),
                    email: Yup.string()
                      .email("Email is invalid!")
                      .required("Email is required!"),
                    password: Yup.string().trim()
                      .min(6, "Password must be at least 6 characters!")
                      .required("Password is required!")
                      .matches(
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#_%^*])/,
                        "Password must contain at least 1 lowercase, uppercase, numeric and special symbol."
                      ),
                    confirmPassword: Yup.string().trim()
                      .oneOf(
                        [Yup.ref("password"), null],
                        "Passwords must match"
                      )
                      .required("Confirm Password is required!"),
                  })}
                  validate={(values) => {
                    let errors = {};
                    if (alreadyInUseEmail.includes(values.email)) {
                      errors.email = "Email address already in use";
                    }
                    return errors;
                  }}
                  // Post Data to API
                  onSubmit={async (data, actions) => {
                    this.setState({
                      isLoading: true,
                    });
                    actions.setSubmitting(false);
                    try {
                      const response = await api.post("user/register", {
                        email: data.email,
                        password: data.password,
                        role_id: 1,
                        first_name: data.firstName,
                        last_name: data.lastName,
                      });
                      if (response.status === 200) {
                        this.setState({
                          isLoading: false,
                        });
                        setTimeout(() => {
                          actions.resetForm({});
                        }, 5000);
                        actions.setStatus({
                          success: response.data.message,
                        });
                      }
                    } catch (error) {
                      // Error
                      this.setState({
                        isLoading: false,
                      });
                      if (error.response) {
                        actions.setFieldError("email", "Email is already used");
                        alreadyInUseEmail.push(data.email);
                      } else {
                        console.log(`Axios request failed: ${error}`);
                      }
                    }
                  }}
                  >
                  {({ isSubmitting, errors, status, touched }) => (
                    <Form>
                      <h2 className="ff-montserrat-sb text-center">
                        Create Account
                      </h2>
                      <div className="form-group">
                        <label htmlFor="firstName">License Key</label>
                        <Field
                          name="licenseKey"
                          type="text"
                          onChange={this.handleInputChange}
                          disabled={this.state.model.isLicenseVerified}
                          className={
                            `form-control ${style.customFormControl}` +
                            (errors.licenseKey && touched.licenseKey
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="licenseKey"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group mt-2 mb-4">
                        { !this.state.isLicenseKeyLoading && !this.state.model.isLicenseVerified && (
                        <button
                          type="button"
                          disabled={!this.state.model.licenseKey}
                          onClick={this.validateLicenseKey}
                          className={`btn btn-block techtomed-btn-primary ${style["techtomed-btn-primary"]}`}
                        >
                          Validate License
                        </button>)}
                        {this.state.isLicenseKeyLoading && (
                          <div className={style.loadingWrapper}>
                            <img src={ttmLodader} alt="loader" className="loader-image" />
                          </div>
                        )}
                          {!this.state.isLicenseKeyLoading && this.state.successMessage && (
                            <span className={style.successMessage}>
                              {this.state.successMessage}
                            </span>
                          )}
                          {!this.state.isLicenseKeyLoading && this.state.errorMessage && (
                            <span className={style.errorMessage}>
                              {this.state.errorMessage}
                            </span>
                          )}
                      </div>
                      {this.state.model.isLicenseVerified && (
                      <React.Fragment>
                      <div className="form-group">
                        <label htmlFor="firstName">First Name</label>
                        <Field
                          name="firstName"
                          type="text"
                          disabled={this.state.model.isLicenseVerified}
                          className={
                            `form-control ${style.customFormControl}` +
                            (errors.firstName && touched.firstName
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="firstName"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="lastName">Last Name</label>
                        <Field
                          name="lastName"
                          type="text"
                          disabled={this.state.model.isLicenseVerified}
                          className={
                            `form-control ${style.customFormControl}` +
                            (errors.lastName && touched.lastName
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="lastName"
                          disabled={this.state.model.isLicenseVerified}
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <Field
                          name="email"
                          disabled={this.state.model.isLicenseVerified}
                          type="text"
                          className={
                            `form-control ${style.customFormControl}` +
                            (errors.email && touched.email ? " is-invalid" : "")
                          }
                        />
                        <ErrorMessage
                          name="email"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <Field
                          name="password"
                          type="password"
                          className={
                            `form-control ${style.customFormControl}` +
                            (errors.password && touched.password
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="password"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="form-group">
                        <label htmlFor="confirmPassword">
                          Confirm Password
                        </label>
                        <Field
                          name="confirmPassword"
                          type="password"
                          className={
                            `form-control ${style.customFormControl}` +
                            (errors.confirmPassword && touched.confirmPassword
                              ? " is-invalid"
                              : "")
                          }
                        />
                        <ErrorMessage
                          name="confirmPassword"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>

                      {/* Registration success message */}
                      <div className={style.sucessMessage}>
                        {(status && status.success) || ""}
                      </div>

                      <div className="form-group mt-4">
                        <button
                          type="submit"
                          className={`btn btn-block techtomed-btn-primary ${style["techtomed-btn-primary"]}`}
                          disabled={isSubmitting}
                        >
                          Register
                        </button>
                      </div>
                      </React.Fragment>)}
                      <p className="text-center">
                        Already have an account, then{" "}
                        <Link to="/login" className={style.loginText}>
                          login here
                        </Link>
                      </p>
                      {this.state.isLoading && (
                        <div className={style.loadingWrapper}>
                          <img src={ttmLodader} className="loader-image" />
                        </div>
                      )}
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    licenseStatusData: state.licenseStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    verifyLicense: (searchKey, sortBy, page, outofstock) =>
      dispatch(verifyLicense(searchKey, sortBy, page, outofstock)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateAccount);

